// extracted by mini-css-extract-plugin
export var goodsList = "goods-module--goodsList--2IA_Q";
export var actions = "goods-module--actions--1ELhm";
export var action = "goods-module--action--2Go5q";